export default "__VITE_ASSET__BVOHfxNZ__"